<script>
  const server_config = {
    url: 'http://localhost:8080'
  };
  export default {
    server_config
  }
</script>




// WEBPACK FOOTER //
// src/Global.vue